import { qualifyUrl } from "util/URLUtils";
import ApiRouter from "routing/ApiRoutes";
import EnterpriseApiRoutes from "common/ApiRoutes";
import fetch from "logic/rest/FetchProvider";
import { stringifyFilters } from "security-app/components/common/Filters/stringifyFilters";
export const fetchSigmaRules = async (page, perPage, query = null, orderBy = "parsed_rule.title", direction = "asc", filters = {}, userTimezone = null, onlyMatchingSystemConfig = false) => {
  const params = [`page=${page}`, `per_page=${perPage}`, `sort=${orderBy}`, `direction=${direction}`];
  if (query) params.push(`query=${query}`);
  if (filters && Object.keys(filters).length > 0) {
    params.push(`filters=${encodeURI(stringifyFilters(filters))}`);
    params.push(`user_timezone=${encodeURI(userTimezone)}`);
  }
  const func = onlyMatchingSystemConfig ? EnterpriseApiRoutes.SecurityApp.allSigmaRulesThatMatch : EnterpriseApiRoutes.SecurityApp.allSigmaRules;
  return fetch("GET", qualifyUrl(func(params.join("&")).url));
};
export const fetchSigmaRulesFilterOptions = async ({ fields }) => {
  const payload = {
    fields
  };
  return fetch("POST", qualifyUrl(EnterpriseApiRoutes.SecurityApp.sigmaFilters().url), payload);
};
export const fetchStreams = async () => fetch("GET", qualifyUrl(ApiRouter.StreamsApiController.index().url));
export const fetchNotifications = async () => fetch("GET", qualifyUrl("events/notifications"));
export const createSigmaRule = async (payload) => {
  const { share_request, ...rest } = payload;
  fetch("POST", qualifyUrl(EnterpriseApiRoutes.SecurityApp.createSigmaRule().url), { entity: rest, share_request });
};
export const updateSigmaRule = async (payload) => fetch("PUT", qualifyUrl(EnterpriseApiRoutes.SecurityApp.oneSigmaRule(payload.id).url), payload);
export const getSigmaRule = async (ruleId) => fetch("GET", qualifyUrl(EnterpriseApiRoutes.SecurityApp.oneSigmaRule(ruleId).url));
export const validateSigmaRule = async (ruleSource) => fetch("POST", qualifyUrl(EnterpriseApiRoutes.SecurityApp.validateSigmaRule().url), ruleSource);
export const toggleSigmaRule = async ({ ruleId, enable }) => {
  const action = enable ? "enable" : "disable";
  return fetch("PUT", qualifyUrl(EnterpriseApiRoutes.SecurityApp.toggleSigmaRule(ruleId, action).url));
};
export const deleteSigmaRule = async ({ ruleId }) => fetch("DELETE", qualifyUrl(EnterpriseApiRoutes.SecurityApp.oneSigmaRule(ruleId).url));
export const addGitRepo = async ({ repo }) => fetch("POST", qualifyUrl(EnterpriseApiRoutes.SecurityApp.sigmaGitRepos().url), repo);
export const addDefaultRepo = async () => fetch("PUT", qualifyUrl(EnterpriseApiRoutes.SecurityApp.defaultSigmaRepo().url));
export const updateGitRepo = async ({ repoId = void 0, repo }) => fetch("PUT", qualifyUrl(EnterpriseApiRoutes.SecurityApp.sigmaGitRepo(repoId).url), repo);
export const deleteSigmaRepo = async ({ repoId }) => fetch("DELETE", qualifyUrl(EnterpriseApiRoutes.SecurityApp.sigmaGitRepo(repoId).url));
export const listRepoContent = async (repoId, path = "", query = "") => fetch("GET", qualifyUrl(EnterpriseApiRoutes.SecurityApp.sigmaGitRepo(repoId, path, query).url));
export const importRulesFromRepo = async ({ rules, share_request }) => fetch("POST", qualifyUrl(EnterpriseApiRoutes.SecurityApp.importRepoSigmaRule().url), {
  entity: { rules },
  share_request
});
export const importAllRulesFromRepo = async (payload) => fetch("PUT", qualifyUrl(EnterpriseApiRoutes.SecurityApp.importAllRules().url), payload);
export const refreshRepoRules = async ({ repoId }) => fetch("PUT", qualifyUrl(EnterpriseApiRoutes.SecurityApp.refreshRepoRules(repoId).url));
export const bulkSigmaRule = async ({ ids, action }) => fetch("PUT", qualifyUrl(EnterpriseApiRoutes.SecurityApp.sigmaBulkOperation(action).url), { ids });
export const bulkAddNotifications = async ({
  ids,
  action,
  notifications
}) => fetch("PUT", qualifyUrl(EnterpriseApiRoutes.SecurityApp.sigmaBulkOperation(action).url), { ids, notifications });
export const bulkSigmaRepoDelete = async (ids) => fetch("PUT", qualifyUrl(EnterpriseApiRoutes.SecurityApp.bulkDeleteSigmaRepos().url), { ids });
export const listGitRepos = async (page, perPage, query = null, orderBy = "name", direction = "asc") => {
  const options = [`page=${page}`, `per_page=${perPage}`];
  if (query) options.push(`query=${query}`);
  if (orderBy) options.push(`sort=${orderBy}`);
  if (direction) options.push(`direction=${direction}`);
  return fetch("GET", qualifyUrl(EnterpriseApiRoutes.SecurityApp.allSigmaRepos(options.join("&")).url));
};
export const uploadSigmaRules = async ({
  fileForms,
  body,
  progressCB
}) => {
  const formData = new FormData();
  const http = new XMLHttpRequest();
  fileForms.forEach((fileForm) => {
    const { id, file } = fileForm;
    formData.append("files", new Blob([file], { type: file.type }), id);
  });
  formData.append("body", new Blob([JSON.stringify(body)], { type: "application/json" }));
  return new Promise((resolve, reject) => {
    http.upload.onprogress = ({ loaded, total }) => {
      const percent = Math.ceil(loaded * 100 / total);
      progressCB(percent);
    };
    http.onreadystatechange = () => {
      var _a, _b;
      if (http.readyState === 4) {
        if (http.status === 200) {
          resolve(JSON.parse(http.response));
        } else {
          const errorMessage = (_b = (_a = JSON.parse(http.responseText)) == null ? void 0 : _a.message) != null ? _b : http.statusText;
          reject(new Error(errorMessage));
        }
      }
    };
    http.open("POST", qualifyUrl(EnterpriseApiRoutes.SecurityApp.uploadSigmaRules().url), true);
    http.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    http.setRequestHeader("X-Requested-By", "XMLHttpRequest");
    http.setRequestHeader("Access-Control-Allow-Origin", "*");
    http.send(formData);
  });
};
export const validateSigmaRuleZip = async (file) => {
  const formData = new FormData();
  const http = new XMLHttpRequest();
  formData.append("file", file);
  return new Promise((resolve, reject) => {
    http.onreadystatechange = () => {
      var _a, _b;
      if (http.readyState === 4) {
        if (http.status === 200) {
          resolve(JSON.parse(http.response));
        } else {
          const errorMessage = (_b = (_a = JSON.parse(http.responseText)) == null ? void 0 : _a.message) != null ? _b : http.statusText;
          reject(new Error(errorMessage));
        }
      }
    };
    http.open("POST", qualifyUrl(EnterpriseApiRoutes.SecurityApp.validateSigmaRuleZip().url), true);
    http.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    http.setRequestHeader("X-Requested-By", "XMLHttpRequest");
    http.setRequestHeader("Access-Control-Allow-Origin", "*");
    http.send(formData);
  });
};
